const About = () => {


	
	return (
		<div className="container-xxl flex-grow-1 container-p-y">
			<div className="row">
				<div className="col-12">
					<span className="text-danger fw-bold fs-2x">This is about page</span>
				</div>
			</div>
		</div>
	);
};

export default About;
